<template>
    <div class="plugin-home-image"
         v-bind:class="{ [`_${theme}`]: true }"
         v-bind:style="{ '--img-position': position }"
         v-if="image"
    >
        <div v-if="title" class="plugin-home-image__title">
            {{ title }}
        </div>
        <img
            v-bind:src="getResizedUrl(image, 640)"
            v-bind:alt="title"
            v-bind:srcset="srcset"
        />
    </div>
</template>

<script>
// TODO srcset / sizes, lazyload
export default {
    name: 'plugin-home-image',
    props: {
        image: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        theme: {
            type: String,
            default: 'default',
        },
        position: {
            type: String,
            default: 'center',
        },
    },
    computed: {
        srcset() {
            // const widths = [320, 480, 640, 768, 1024, 1280, 1536];
            const widths = [480, 640, 768, 1024, 1280];
            return widths
                .map(w => `${this.getResizedUrl(this.image, w)} ${w}w`)
                .join(', ');
        },
    },
    methods: {
        getResizedUrl(url, width) {
            if (!url) return url;

            const lastSlash = url.lastIndexOf('/');
            if (lastSlash === -1) return url;

            const base = url.substring(0, lastSlash);
            const filename = url.substring(lastSlash + 1);

            if (filename.includes('xAUTO')) return url;

            return `${base}/${width}xAUTO/${filename}`;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.plugin-home-image {
    --img-position: center;

    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: @border-radius-xxl;

    &__title {
        .typography-small();

        position: absolute;
        left: 20px;
        top: 18px;
        padding: 12px 18px;
        background-color: @color-gray-lightest;
        border-radius: 999px;

        font-weight: bold;
    }

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: var(--img-position);
    }

    &._white {
        border: 1px solid @color-gray-lightest;
    }
    &._gray {
        border: 1px solid @color-gray-light-secondary;
    }

    @media @media-md-down {
        border-radius: @border-radius-xll;

        &__title {
            .typography-caption();

            left: 12px;
            top: 12px;
            padding: 8px 12px;
            font-weight: bold;
        }
    }
}
</style>
